import type { ComandoDeBarra } from '@remoto/protocolo';

/**
 * A lógica da barra `/`, sem DOM.
 *
 * Comando de barra é a MENSAGEM INTEIRA — é assim que o Claude Code funciona,
 * e é o que mata os falsos positivos de graça: `http://`, caminho de arquivo
 * e `/` no meio de uma frase nunca abrem o menu.
 */

/** Abre quando o texto começa com `/` e o cursor ainda está no primeiro token. */
export function detectarBarra(texto: string, cursor: number): { termo: string } | null {
  if (!texto.startsWith('/')) return null;
  const primeiroToken = /^\/(\S*)/.exec(texto);
  if (!primeiroToken) return null;
  const fimDoToken = 1 + (primeiroToken[1]?.length ?? 0);
  if (cursor < 1 || cursor > fimDoToken) return null;
  return { termo: (primeiroToken[1] ?? '').toLowerCase() };
}

/**
 * Prefixo no nome > prefixo em alias > substring no nome > substring na
 * descrição. Ordenação estável dentro de cada faixa; teto de 50 na tela.
 */
export function filtrarComandos(comandos: ComandoDeBarra[], termo: string): ComandoDeBarra[] {
  const visiveis = comandos.filter((c) => !c.soNoTerminal);
  if (!termo) return visiveis.slice(0, 50);

  const t = termo.toLowerCase();
  const faixaDe = (c: ComandoDeBarra): number => {
    const nome = c.nome.toLowerCase();
    if (nome.startsWith(t)) return 0;
    if (c.aliases.some((a) => a.toLowerCase().startsWith(t))) return 1;
    if (nome.includes(t)) return 2;
    if (c.descricao.toLowerCase().includes(t)) return 3;
    return -1;
  };

  return visiveis
    .map((c, ordem) => ({ c, ordem, faixa: faixaDe(c) }))
    .filter((x) => x.faixa >= 0)
    .sort((a, b) => a.faixa - b.faixa || a.ordem - b.ordem)
    .map((x) => x.c)
    .slice(0, 50);
}

/** O texto do campo depois de completar: `/nome ` pronto para o argumento. */
export function completarComando(texto: string, nome: string): string {
  const resto = texto.replace(/^\/\S*/, '');
  return '/' + nome + (resto.startsWith(' ') ? resto : ' ' + resto.trimStart());
}
